import React from 'react';
import Calculator from './Calculator';
import Signature from './Signature/Signature';
import './App.css';

function App() {
  return (
    <div className="App">
      <Calculator />
      <Signature />
    </div>
  );
}

export default App;
